/* eslint no-console: "off" */
import common from '../common/index';

export default {
  updateColors(state, colors) {
    state.colors = colors;
  },
  updateGameName(state, gameName) {
    state.gameName = gameName;
  },
  updateGameMode(state, gameMode) {
    state.gameMode = gameMode;
  },
  updateGameType(state, gameType) {
    state.gameType = gameType;
  },
  setTotalUserPoints(state, payload) {
    state.totalUserPoints = payload;
  },
  setPointsPerMiniGame(state, payload) {
    state.pointsPerMiniGame = payload;
  },
  setPlayersPostGameData(state, payload) {
    // store home player post game data
    state.playersDetails.gamesPlayed = payload.gamesPlayed;
    state.playersDetails.gamesWon = payload.gamesWon;
    state.playersDetails.iqPoints = payload.iqPoints;
    state.playersDetails.bonusPoints = payload.bonusPoints;
    state.playersDetails.pointsPerMiniGame = payload.pointsPerMiniGame;
    state.playersDetails.totalUserPoints = payload.totalUserPoints;
    state.playersDetails.pointsEarned = payload.pointsEarned;
  },
  resetPrizePostGameData(state) {
    state.unauthorizedWinnerInfo.msisdn = null;
    state.unauthorizedWinnerInfo.code = null;
    state.unauthorizedWinnerInfo.gameType = null;
    state.unauthorizedWinnerInfo.prizeId = null;
    state.unauthorizedWinnerInfo.name = null;
    state.unauthorizedWinnerInfo.imageWonUrl = null;
    state.unauthorizedWinnerInfo.existPrize = false;
  },
  updateUnauthorizedWinnerInfo(state) { // retrieves data from Vuex to pass them to home page
    state.unauthorizedWinnerInfo.msisdn = common.state.unauthorizedMsisdn;
    state.unauthorizedWinnerInfo.code = common.state.code;
    state.unauthorizedWinnerInfo.gameType = state.gameType;
    state.unauthorizedWinnerInfo.prizeId = state.playersDetails.winDTO.id;
    state.unauthorizedWinnerInfo.name = state.playersDetails.winDTO.name;
    state.unauthorizedWinnerInfo.imageWonUrl = state.playersDetails.winDTO.imageWonUrl;
    state.unauthorizedWinnerInfo.existPrize = true;
  },
  isGamePageFlow(state, booleanVal) {
    state.isGamePage = booleanVal;
  },
  setUserLeveledUp(state, userLeveledUp) {
    state.playersDetails.levelUp = userLeveledUp;
  },
  resetGameState(state) {
    state.totalUserPoints = 0;
    state.gameName = null;
    state.colors = null;
    state.gameMode = null;
    state.playersDetails = {};
    state.gameInProgress = false;
    state.gameID = null;
    state.gameFinished = false;
    state.gameType = null;
    state.miniGameType = null;
    state.currentMiniGameRound = 0;
    state.pointsPerMiniGame = 0;
    state.miniGames = [];
  },
  resetPrizeData(state) {
    state.playersDetails = [];
  },
  updatePrizePostGameData(state, payload) {
    state.playersDetails.winDTO = payload.winDTO;
    state.playersDetails.lostDTOs = payload.lostDTOs;
  },
  setShuffledCardDTOS(state, payload) {
    state.shuffledCardDTOS = payload.sdCardsShuffled;
  },
  setGameType(state, payload) {
    state.gameType = payload;
  },
  setMiniGameType(state, payload) {
    state.miniGameType = payload;
  },
  setCurrentMiniGameRound(state, payload) {
    state.currentMiniGameRound = payload;
  },
  setSpecificMiniGameFields(state, { index, correct }) {
    state.miniGames[index].answered = true;
    state.miniGames[index].correct = correct;
  },
  setMiniGames(state, payload) {
    state.miniGames = payload;
  },
  setMiniGameAnswer(state, {index, data}) {
    state.miniGames[index].correct = data.correct;
    state.miniGames[index].userAnswerInfo.text = data.userAnswerInfo.text;
    state.miniGames[index].userAnswerInfo.choice = data.userAnswerInfo.choice;
    state.miniGames[index].answered = data.answered;
  },
  setMiniGamesImagesForSwipe(state, payload) {
    state.miniGamesImagesForSwipe = payload;
  },
  setGameDTOForResumeGameOnly(state, gameStateEnumForResumeGame) {
    state.gameStateEnumForResumeGame = gameStateEnumForResumeGame;
  },
  setTransitionOnlyForSearchingToOpponent(state, value) {
    state.transitionOnlyForSearchingToOpponent = value;
  },
  setGameInProgress(state, gameInProgress) {
    state.gameInProgress = gameInProgress;
  },
  setGameID(state, gameID) {
    state.gameID = gameID;
  },
  setGameFinishedStatus(state, gameFinished) {
    state.gameFinished = gameFinished;
  },
  storeRegistrationPoints(state, points) {
    state.registrationPoints = points;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/game/mutations.js